module.exports = __webpack_public_path__ + "static/media/whichThinnerCost.d596abbd.mp3";